<section class="page">
  <header class="page-header">
    <div>
      <h1>Transactions</h1>
      <p>Search and inspect all platform money movements</p>
    </div>
    <div class="header-actions">
      <button
        class="btn btn-secondary"
        type="button"
        (click)="sync()"
        [disabled]="syncing() || loading()"
      >
        {{ syncing() ? 'Syncing…' : 'Sync from Kobble' }}
      </button>
    </div>
  </header>

  @if (error()) {
    <div class="alert alert-error">{{ error() }}</div>
  }
  @if (success()) {
    <div class="alert alert-success">{{ success() }}</div>
  }

  <div class="panel filters">
    <div class="filter-grid">
      <label>
        <span>Email</span>
        <input type="text" [(ngModel)]="email" placeholder="user@email.com" (keyup.enter)="applyFilters()" />
      </label>
      <label>
        <span>User ID</span>
        <input type="text" [(ngModel)]="userId" placeholder="123" (keyup.enter)="applyFilters()" />
      </label>
      <label>
        <span>Sender user ID</span>
        <input type="text" [(ngModel)]="senderUserId" placeholder="initiated by" (keyup.enter)="applyFilters()" />
      </label>
      <label>
        <span>Receiver</span>
        <input type="text" [(ngModel)]="receiver" placeholder="name / account / wallet" (keyup.enter)="applyFilters()" />
      </label>
      <label>
        <span>Search</span>
        <input type="text" [(ngModel)]="q" placeholder="reference, kobble id…" (keyup.enter)="applyFilters()" />
      </label>
      <label>
        <span>Type</span>
        <select [(ngModel)]="type">
          <option value="">Any</option>
          <option value="rent">rent</option>
          <option value="transfer">transfer</option>
          <option value="topup">topup</option>
          <option value="withdrawal">withdrawal</option>
          <option value="refund">refund</option>
          <option value="other">other</option>
        </select>
      </label>
      <label>
        <span>Status</span>
        <select [(ngModel)]="status">
          <option value="">Any</option>
          <option value="pending">pending</option>
          <option value="processing">processing</option>
          <option value="completed">completed</option>
          <option value="failed">failed</option>
          <option value="cancelled">cancelled</option>
        </select>
      </label>
      <label>
        <span>Leg</span>
        <select [(ngModel)]="leg">
          <option value="">Any</option>
          <option value="collection">collection</option>
          <option value="payout">payout</option>
          <option value="transfer">transfer</option>
          <option value="topup">topup</option>
          <option value="other">other</option>
        </select>
      </label>
      <label>
        <span>To party</span>
        <select [(ngModel)]="toPartyType">
          <option value="">Any</option>
          <option value="merchant_wallet">merchant_wallet</option>
          <option value="user_wallet">user_wallet</option>
          <option value="beneficiary">beneficiary</option>
          <option value="external_bank">external_bank</option>
        </select>
      </label>
    </div>
    <div class="filter-actions">
      <button class="btn btn-primary" type="button" (click)="applyFilters()" [disabled]="loading()">Search</button>
      <button class="btn btn-secondary" type="button" (click)="clearFilters()" [disabled]="loading()">Clear</button>
    </div>
  </div>

  <div class="panel">
    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>User / sender</th>
            <th>Receiver</th>
            <th>Leg</th>
            <th>Type</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Reference</th>
            <th>Created</th>
          </tr>
        </thead>
        <tbody>
          @if (loading()) {
            <tr><td colspan="9" class="muted">Loading…</td></tr>
          } @else if (!rows().length) {
            <tr><td colspan="9" class="muted">No transactions</td></tr>
          } @else {
            @for (row of rows(); track row.id) {
              <tr class="clickable" [routerLink]="['/transactions', row.id]">
                <td>{{ row.id }}</td>
                <td>{{ userLabel(row) }}</td>
                <td>{{ receiverLabel(row) }}</td>
                <td>{{ row.leg || '—' }}</td>
                <td>{{ row.type || '—' }}</td>
                <td>{{ row.amount }} {{ row.currency || '' }}</td>
                <td>
                  <span class="badge" [attr.data-status]="row.status">{{ row.status || '—' }}</span>
                </td>
                <td>{{ row.reference || '—' }}</td>
                <td>{{ row.created_at ? (row.created_at | date: 'medium') : '—' }}</td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>

    <div class="pager">
      <span class="muted">Page {{ page() }} of {{ totalPages() }} · {{ total() }} total</span>
      <div class="pager-actions">
        <button class="btn btn-secondary" type="button" (click)="prev()" [disabled]="page() <= 1 || loading()">
          Previous
        </button>
        <button
          class="btn btn-secondary"
          type="button"
          (click)="next()"
          [disabled]="page() >= totalPages() || loading()"
        >
          Next
        </button>
      </div>
    </div>
  </div>
</section>
